module.exports = __webpack_public_path__ + "img/whbt.99294886.png";